import React, {useMemo} from 'react';
import {useSuspenseQuery} from "@tanstack/react-query";
import {secretApi} from "../../../api/api";

const UseClanApi = () => {
    const query = useSuspenseQuery(
        {
            queryKey: ['clanApi'],
            queryFn: async () => {
                const clans = await clanInfoApi()
                return clans
            },
            staleTime: Infinity,
        })


    const list = useMemo(() => {
        if (!query?.data) {
            return []
        }
        return query.data
    }, [query.data])

    return {query, list};



};
const clanInfoApi = async () => {
    try {
        // const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_first_player`);
        const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/server_list`);
        const result = await secretApi.get(url.toString());


        const clanList = result.data.clan_list

        return clanList
    } catch (e) {
        console.log(e)
        return {};
    }
}
export default UseClanApi;